import { exportToCsv } from '../../../../designSystem/DataExporter/utils/exportToCsv';

const headers = [
  { key: 'businessDestinationName', label: 'NOMBRE DEL CLIENTE' },
  { key: 'businessDestinationIdentifier', label: 'RUT CLIENTE' },
  { key: 'businessDestinationNumber', label: 'N° CTA' },
  { key: 'amount', label: 'VALOR A PAGAR' },
  { key: 'bankCode', label: 'N° BANCO' },
  { key: 'firstNumber', label: 'N°FIJO' },
  { key: 'secondNumber', label: 'N°FIJO' },
  { key: 'thirdNumber', label: 'N°FIJO' },
  { key: 'forthNumber', label: 'N°FIJO' },
  { key: 'operationNumber', label: 'N°COMB' },
  { key: 'destinationHolderEmail', label: 'CORREO' },
];

export const handleExportBICECsv = async (
  payments: any,
  id: any,
  message?: string,
) => {
  const data = payments.map((x: any) => {
    return {
      businessDestinationName: x.businessDestinationName,
      businessDestinationIdentifier: x.businessDestinationIdentifier,
      businessDestinationNumber: x.bankAccountDestinationNumber,
      amount: x.amount,
      bankCode: x.bankAccountDestinationBankCode,
      firstNumber: '1',
      secondNumber: '0',
      thirdNumber: '1',
      forthNumber: '1',
      operationNumber: x.sourceId,
      destinationHolderEmail: x.bankAccountDestinationHolderEmail,
    };
  });

  exportToCsv(
    data,
    headers,
    `Bice_${id}_${new Date().toDateString()}.csv`,
    ';',
  );
};
